import {inject, Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {environment} from '../../environments/environment'
import {HttpClient} from '@angular/common/http'
import {
  DocumentActionInput,
  DocumentItem,
  IAutogiroAccounts
} from '@sparbanken-syd/borgo-types'

import {LOCAL_STORAGE} from '../application/providers'

const TEMP_KEY = 'TEMP_KEY'

export interface LoginResponse {
  url: string
}

export interface ISessionToken {
  /**
   * If we have an ID that means that we have a registered account,
   * else, we set it to the id of the request and false
   */
  id?: string
  temp?: boolean
  autogiroPossible: boolean
  accounts: IAutogiroAccounts[]
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  private readonly http = inject(HttpClient)
  private readonly storage = inject(LOCAL_STORAGE)


  /**
   * Start the login procedure, it will trigger a long line
   * of 302s and eventually end up in /code
   */
  public initiateLogin(path: string): Observable<LoginResponse> {
    const url = `${environment.apiUrl}/${path}`
    return this.http.get<LoginResponse>(url)
  }

  /**
   * Get documents
   */
  public documents(id: string): Observable<DocumentItem[]> {
    const url = `${environment.apiUrl}/users/${id}/documents`
    return this.http.get<DocumentItem[]>(url)
  }

  public approveDocuments(id: string, documents: DocumentItem[]): Observable<LoginResponse> {
    const data: DocumentActionInput = {
      action: 'APPROVE',
      documents: [],
      userId: id
    }
    // Make sure here not to send binary data etc
    data.documents = documents.map((d: DocumentItem) => ({
      id: d.id,
      hash: d.hash,
      title: d.title,
      category: d.category,
      isAutogiro: d.isAutogiro
    }))
    /**
     * Intention is to return 200 OK if ok, 404 if the document does not
     *  exist, etc.
     */
    const url = `${environment.apiUrl}/users/${id}/documents`
    return this.http.put<LoginResponse>(url, data)
  }

  /**
   *
   */
  public startAutoGiroId(bban: string, id: string): Observable<LoginResponse> {
    const url = `${environment.apiUrl}/autogiro`
    return this.http.post<LoginResponse>(url, {bban, id})
  }

  public startAutoGiroPnr(bban: string, personNummer: string) {
    const url = `${environment.apiUrl}/autogiro`
    return this.http.put<LoginResponse>(url, {bban, personNummer})
  }

  /**
   * Add a random token
   * @param token -
   */
  public addToken(token: ISessionToken): void {
    this.storage.setItem(TEMP_KEY, JSON.stringify(token))
  }

  public getToken(): ISessionToken {
    const stored = this.storage.getItem(TEMP_KEY) ?? JSON.stringify(
      {
        autogiroPossible: false,
        accounts: []
      } as ISessionToken)
    return JSON.parse(stored)
  }

  public removeToken(): void {
    return this.storage.removeItem(TEMP_KEY)
  }

  public hideAutogiro(hide: boolean) {
    this.storage.setItem('HIDEOUS', `${hide}`)
  }

  public autoGiroHidden(): boolean {
    return this.storage.getItem('HIDEOUS') === 'true'
  }
}
